module.exports = __webpack_public_path__ + "img/16d001-31.5c849bb5.png";